// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  title: 'Alteração de cadastro',
  one: `1. Alterar informações cadastrais <strong>desconecta o usuário imediatamente</strong>,
  para que uma nova credencial seja carregada com as informações atualizadas`,
  two: '2. Toda <strong>alteração fica pendente</strong> até que seja validada com a senha do usuário',
} as ILanguage;
